import { Ng1StateDeclaration } from '@uirouter/angularjs';

import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [{
    name: 'approvalConfiguration',
    url: '/approvalConfiguration/:approvalStrategyGuid',
    component: 'wtApprovalConfigurationState',
    resolve: {
    },
    params: {
        returnParams: null
    },
    data: {
        sortingOrder: -1,
        icon: '',
        displayName: 'Approval',
        editRoles: [Roles.administrator, Roles.master, Roles.engineer],
        editButtonVisibility: () => true,
        editButtonDisabled: () => true
    }
}];

export default states;